function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 7.945l7.334 6.6V26H20.4v-8.8h-8.8V26H8.667V14.545L16 7.945zM16 4L1.334 17.2h4.4v11.733h8.8v-8.8h2.933v8.8h8.8V17.2h4.4L16 4z",
  fill: "#000"
});

var SvgLineHome = function SvgLineHome(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='m16 7.945 7.334 6.6V26H20.4v-8.8h-8.8V26H8.667V14.545L16 7.945zM16 4 1.334 17.2h4.4v11.733h8.8v-8.8h2.933v8.8h8.8V17.2h4.4L16 4z' fill='%23000000'/%3E %3C/svg%3E";
export { SvgLineHome as ReactComponent };